import { FC } from 'react';
import { useTranslation } from '@jobcost-monorepo/i18n';
import { Button } from '@jobcost-monorepo/ui';
import { useFormContext } from 'react-hook-form';
import { CustomApiClient, IBaseModel, IListFetchParams } from '../../../common';
import React from 'react';

interface IResponseTotalWorked extends IBaseModel {
  resourceId: number;
  workedHours: number;
}

interface ITotalWorkedFetchParams extends IListFetchParams {
  jobId: number;
  orderId: number;
  resourceId: number;
  startDate: string;
  endDate: string;
  markType: string;
}

const GetTotalWorkedHoursButton: FC = () => {
  const { t } = useTranslation('activities');
  const { setValue, watch } = useFormContext();
  const jobId = watch('jobId');
  const resourceId = watch('resourceId');
  const orderId = watch('orderId');
  const startDate = watch('startDate');
  const endDate = watch('endDate');

  const getTotalHours = async () => {
    try {
      const props: ITotalWorkedFetchParams = {
        jobId,
        orderId,
        resourceId,
        startDate,
        endDate,
        markType: 'WorkedHours',
        search: '',
        skip: 0,
        take: 10,
      };

      const customApiClient = new CustomApiClient();
      const response = await customApiClient.getMany<
        IResponseTotalWorked,
        ITotalWorkedFetchParams
      >('timesheets/getTotalWorkedHours', props);

      if (response.succeeded) {
        const workedHours =
          response.data?.data && response.data?.data?.length > 0
            ? response.data?.data[0].workedHours
            : null;
        setValue('workedHours', workedHours);
      }
    } catch (error: any) {
      console.log(error);
    }
  };
  return (
    <div className="flex flex-col justify-center align-middle space-x-4">
      <Button
        type="button"
        onClick={getTotalHours}
        disabled={!(jobId && resourceId && orderId && startDate && endDate)}
      >
        {t('form.getTotalWorkedHours')}
      </Button>
    </div>
  );
};

export default GetTotalWorkedHoursButton;
